import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./OriginCertificateList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'
import formatDate from '../../helpers/formatDate';
import { downloadFile } from '../../utils/utilFile';
import { ButtonStandard, OriginCertificateListFilter, ToastMessage, LoadingSpinner } from "../../components";

function OriginCertificateList(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);

    const isLoadingList         = useSelector(state => state.originCertificate.isLoadingList);
    const originCertificateList = useSelector(state => state.originCertificate.originCertificateList); 
    const page                  = useSelector(state => state.originCertificate.page);
    const hasMore               = useSelector(state => state.originCertificate.hasMore);
    const filters               = useSelector(state => state.originCertificate.filter);
    const isLoading             = useSelector(state => state.originCertificate.isLoading);
    const toast                 = useSelector(state => state.originCertificate.toast);
        
    const [isTableEmpty, setIsTableEmpty] = useState(false)
    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');

    const [renderCount, setRenderCount] = useState(0);

    const titlePage    = messages[lang].originCertificatePage.title
	const pageMessages = messages[lang].originCertificatePage;
	const titleTable   = messages[lang].idgfPage.table;

	const header = [
		pageMessages.codigo,
        pageMessages.dataAtualizacao,
        pageMessages.dataCadastro,
        pageMessages.fornecedor,
        pageMessages.pedido,
        ""
	];

    useEffect(() => {
		dispatch({
			type: 'GET_ORIGIN_CERTIFICATE_LIST',
            payload: {
                page: 1,
                filters: filters,
                cleanTable: true
            }
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (renderCount >= 1) {
            setShowToast(toast.showToast)
            setMessageError(toast.message)
            setMessageType(toast.messageType)
        } else {
            let count = parseInt(renderCount) + 1
            setRenderCount(count)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toast]);

    useEffect(() => {
		if (originCertificateList.length > 0) {
			setIsTableEmpty(false)
		} else {
            setIsTableEmpty(true)
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [originCertificateList]);

    const handleHasMore = () => {
		dispatch({
			type: 'GET_ORIGIN_CERTIFICATE_LIST',
            payload: {
                page: page,
                filters: filters
            }
		})
	}

	const mappedFiles = () => {
		return originCertificateList.map((item) => {
			return [
                {
                    text: item.codigo,
                    maxLength: 4000
                },
                {
                    text: item.dataAtualizacao ? formatDate(item.dataAtualizacao): '--/--/----',
                    maxLength: 4000
                },
                {
                    text: item.dataCadastro ? formatDate(item.dataCadastro) : '--/--/----',
                    maxLength: 4000
                },
                {
                    text: item.fornecedor,
                    maxLength: 4000
                },
                {
                    text: item.pedido,
                    maxLength: 4000
                },
                {
                    text: <i className="icon-pen" />,
                    onClick: () => {
                        history.push({
                            pathname: '/origin-certificate-upload',
                            id: item.id,
                            order: item.pedido
                        })
                    },
                }]
		});
	}

    const getOriginCertificateList = () => {
        dispatch({
			type: 'GET_ORIGIN_CERTIFICATE_LIST',
            payload: {
                page: 1,
                filters: filters,
                cleanTable: true
            }
		})
	}


    const mountCsvText = (arrayToText) => {
		const separator = ';';
		return arrayToText.reduce((csvText, currentRow) => {

			const rowText = currentRow.reduce((csvRow, currentColumn) => {
				return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
			}, '');

			return csvText ? `${csvText}\n${rowText}` : rowText
		}, '');
	}

    const downloadCsv = () => {

		let headerTable = header;

        let itemsToDownload =
        originCertificateList
					.map(item => ([
						item.codigo ? item.codigo : '',
						item.dataAtualizacao ? formatDate(item.dataAtualizacao) : '-',
						item.dataCadastro ? formatDate(item.dataCadastro) : '',
						item.fornecedor ? item.fornecedor : '',
						item.pedido ? item.pedido : '',
					]));
			
        const filename = pageMessages.filename + `.csv`;
        const textCsv = mountCsvText([headerTable, ...itemsToDownload]);
        downloadFile(textCsv, filename);
			
	}

	return (
		<div className="origin-certificate-list-page"> 
            {
                isLoading ? 
                <div className="loader">
                    <LoadingSpinner />    
                </div>                 
                :

                null
            }   

            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
             
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
                <OriginCertificateListFilter />
            </Container>

            <Container className="px-4 d-flex justify-content-end">
                <ButtonStandard
					text={pageMessages.newOriginCertificate}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => history.push('/origin-certificate-upload')}/>

                <ButtonStandard
					text={'CSV'}
					textClass="text-1"
					className="btn-sm default btn-outline-success btn-standard px-2 mr-2"
					onClick={() => downloadCsv()}/>

				<ButtonStandard
					text={pageMessages.search}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getOriginCertificateList()}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedFiles()}
                        isLoading={isLoadingList && originCertificateList.length === 0 ? true : false}
                        isEmpty={isTableEmpty}
                        hasMore={hasMore}
                        handleHasMore={handleHasMore}
                        hasMoreIsLoading={isLoadingList}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(OriginCertificateList);